import * as React from 'react';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import { CSSObject } from '@mui/material/styles';
import { IComponentCss } from '../styles';

export enum WidgetVariant {
    Base = 'base',
    Filter = 'filter',
    Info = 'info',
}

const widgetVarianCss: { [key in WidgetVariant]: IComponentCss } = {
    [WidgetVariant.Base]: {},
    [WidgetVariant.Filter]: {
        widget: {
            backgroundColor: '#F0F8FF',
        },
    },
    [WidgetVariant.Info]: {
        widget: {
            backgroundColor: 'cornsilk',
        },
    },
}

const css: IComponentCss = {
    widget: {
        position: 'relative',
        border: '1px solid #E0E0E0',
        borderRadius: '4px',
        padding: '20px',
    },
    title: {
        fontWeight: 400,
        fontSize: '16px',
        marginBottom: '14px',
    },
}


export type WidgetProps = {
    title?: string,
    children: React.ReactNode,
    variant?: WidgetVariant,
    widgetSx?: CSSObject,
    titleSx?: CSSObject,
}

export const Widget = ({
    children,
    title,
    variant = WidgetVariant.Base,
    widgetSx,
    titleSx,
}: WidgetProps) => {
    const variantCss = widgetVarianCss[variant];

    return (
        <Grid
            sx={{
                ...css.widget,
                ...variantCss.widget,
                ...widgetSx,
            }}>
            {title &&
                <Typography
                    component='h6'
                    color="text.primary"
                    gutterBottom
                    sx={{
                        ...css.title,
                        ...variantCss.title,
                        ...titleSx,
                    }}
                >
                    {title}
                </Typography>
            }
            {children}
        </Grid >
    );
}